import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { axios.get(`${API}/orders/${id}`).then((r) => setOrder(r.data)); }, [id]);
  if (!order) return <div className="pt-40 text-center label-mono">Loading order…</div>;
  return (
    <div className="max-w-[720px] mx-auto px-6 pt-40 pb-24 text-center" data-testid="order-success">
      <CheckCircle2 size={48} className="mx-auto text-[var(--primary)]" />
      <div className="label-mono mt-6">Order Confirmed</div>
      <h1 className="font-serif text-5xl mt-4">The roaster is warming up.</h1>
      <p className="mt-4 text-[var(--text-secondary)]">
        We&apos;ve received your order. You&apos;ll get an email at <span className="text-[var(--primary)]">{order.email}</span> once it ships.
      </p>
      <div className="mt-10 border border-[var(--border)] bg-[var(--surface)] p-6 text-left">
        <div className="flex justify-between label-mono mb-4"><span>Order ID</span><span className="font-mono text-[var(--text)]">{order.id}</span></div>
        <div className="flex justify-between label-mono mb-4"><span>Payment</span><span className="font-mono text-[var(--text)] uppercase">{order.payment_method} · {order.payment_status}</span></div>
        {order.upi_reference && (
          <div className="flex justify-between label-mono mb-4"><span>UPI Ref</span><span className="font-mono text-[var(--text)]">{order.upi_reference}</span></div>
        )}
        <div className="flex justify-between label-mono mb-4"><span>Total</span><span className="font-mono text-[var(--primary)]">₹{order.total}</span></div>
        <div className="pt-4 border-t border-[var(--border)] space-y-2">
          {order.items.map((it, i) => (
            <div key={`${it.blend_id || it.name}-${it.weight_g}-${it.grind}-${i}`} className="flex justify-between text-[var(--text-secondary)] text-sm">
              <span>{it.name} · {it.weight_g}g · ×{it.quantity}</span>
              <span className="font-mono">₹{it.price_inr * it.quantity}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-10 flex justify-center gap-3">
        <Link to="/shop" className="btn-outline">Keep Shopping</Link>
        <Link to="/account" className="btn-primary">View Orders</Link>
      </div>
    </div>
  );
}
